import { PropertySearchModel } from './PropertySearchModel';
import * as _ from 'lodash';

export class PropertySearchV4 {

    /*pageNo: number;
    pageSize: number;
    searchField: string;
    searchTerm: string;
    orderID: number;
    departmentName: string;
    departmentID: number;
    categoryName: string;
    isResidential: boolean;
    isResidentialSale: boolean;
    isResidentialLetting: boolean;
    isCommercial: boolean;
    isAgricultural: boolean;
    studentProperties: boolean;
    auctionProperties: boolean;
    priceTypeId: number;
    priceMin: number;
    priceMax: number;
    bedroomsMin: number;
    location: string;
    searchRadius: number;
    mapLongitude: number;
    mapLatitude: number;
    mapZoom: number;
    mapRadius: number;
    noMap: boolean;
    includeLetOrSold: boolean;
    propertyTypes: number[];
    searchScopes: SearchScopeModel[];
    searchGeos: SearchGeoModel[];
    coordinates: CoordinateModel[]
    */

    public isHomePage: boolean;
    public isHomePageInitialisation: boolean;

    public defaultLatitude = 54.974248;
    public defaultLongitude = -1.603980;

    public defaultZoom = 15;
    public defaultRadius = 500;
    public defaultSearchRadius = 0;
    public defaultSearchRadiusHome = 0;

    public propertySearchModel = {
        pageNo: 1,
        pageSize: 12,
        searchField: '',
        searchTerm: '',
        orderID: 1,
        departmentID: 0,
        departmentName: 'residential',
        categoryName: 'lettings',
        priceFrequencyId: 0,
        priceMin: 0,
        priceMax: 0,
        bedroomsMin: 0,
        location: '',
        searchRadius: 0,
        mapLongitude: this.defaultLongitude,
        mapLatitude: this.defaultLatitude,
        mapZoom: this.defaultZoom,
        mapRadius: this.defaultRadius,
        noMap: true,
        includeLetOrSold: false,
        searchScopes: [],
        propertyTypes: [],
        searchGeos: [],
        coordinates: [],
        gridViewMode: '3x' // 1x, 2x, 3x, mapx
    } as PropertySearchModel;

    constructor() {
    }

    public run(): void {
        console.log(`PropertySearchComponent run ${localStorage.getItem("bm-pty-search-init") === "1"}`);

        // Is this the home page or the search listing
        this.isHomePage = true;
        this.isHomePageInitialisation = true;

        // Update hasMap based upon screen size
        this.propertySearchModel.noMap = true;

        // Save fresh search model to localStorage
        localStorage.setItem("bm-pty-search", JSON.stringify(this.propertySearchModel));

        // Reset isHomePageInitialisation after initialisation complete
        this.isHomePageInitialisation = false;
    }

    runHomePropertySearch = () => {
        // Set model basic fields
        this.propertySearchModel.departmentName = $('#hdnSearchDepartmentName').val() != null 
            && $('#hdnSearchDepartmentName').val() != undefined
            && $('#hdnSearchDepartmentName').val() != ''
                ? $('#hdnSearchDepartmentName').val().toString()
                : 'residential';
        this.propertySearchModel.categoryName = $('input[name=searchCategories]:checked').val().toString();
        this.propertySearchModel.location = $('#psearch-locality').val().toString();

        // Save search model to localStorage
        localStorage.setItem("bm-pty-search", JSON.stringify(this.propertySearchModel));
        localStorage.setItem("bm-pty-search-init", "1");

        // Redirect to search page
        /**
            sdept=auction&amp;slocation={R:1}
            sdept={R:1}&amp;scat={R:2}&amp;slocation={R:3}
            sdept [auction, residential, commercial, agricultural]
            scat [sales, lettings, students]
            slocation [name, postcode]

            /residential/sales/location/
            /residential/lettings/location/
            /residential/students/location/
            /saleby/auction/location/
            /commercial/sales/location/
            /commercial/lettings/location/
        */
        let buildUrl = '/';
        if (this.propertySearchModel.categoryName === 'sales') {
            buildUrl += 'sales/find-a-property/';
        } else if (this.propertySearchModel.categoryName === 'lettings') {
            buildUrl += 'lettings/find-a-property/';
        } else if (this.propertySearchModel.categoryName === 'students') {
            buildUrl += 'students/find-a-property/';
        }

        if (this.propertySearchModel.location != null && this.propertySearchModel.location.length > 0) {
            buildUrl += this.propertySearchModel.location.replace(' ', '-');
        }

        // Perform redirect
        window.location.href = buildUrl;
    }    

    setUiThread = () => {
        // TODO: MG
    }

    getIsHomePage = () => {
        return this.isHomePage;
    }

    getSearchCategory = () => {
        return $('input[name=searchCategories]:checked').val().toString();
    }

    setSearchCategory = (category: string) => {
        this.propertySearchModel.categoryName = category;
        $('#hdnSearchCategoryName').val(category);

        // Set include sold items when sales
        if (category === 'sales') {
            this.propertySearchModel.includeLetOrSold = false;
        } else {
            this.propertySearchModel.includeLetOrSold = false;
        }
    }
}

$(document).ready(function () {

    var propertySearch = new PropertySearchV4();
    propertySearch.run();

    // Run search
    $('.search-button').on('click', function (e) {
        e.preventDefault();
        propertySearch.runHomePropertySearch();
    });

    // Radio buttons
    $('#search-scat-sales').click(function (e) {
        $('#hdnSearchCategoryName').val($(this).val());
        propertySearch.setSearchCategory(propertySearch.getSearchCategory());
    });
    $('#search-scat-lettings').click(function (e) {
        $('#hdnSearchCategoryName').val($(this).val());
        propertySearch.setSearchCategory(propertySearch.getSearchCategory());
    });
    $('#search-scat-students').click(function (e) {
        $('#hdnSearchCategoryName').val($(this).val());
        propertySearch.setSearchCategory(propertySearch.getSearchCategory());
    });

});


// WEBPACK FOOTER //
// ./App/PropertySearchHomeV5.ts